{
  "name": "05  skull smasher",
  "title": "SkullSmasher",
  "description": "SkullSmasherDescription",
  "stat": 4,
  "boughtEarlyStat": 52,
  "inventoryStat": 17,
  "lockFlag": 17
}